module.exports = __webpack_public_path__ + "static/img/ic_mart_on@2x.8eef8d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_mart_on@2x.png
// module id = iPvD
// module chunks = 1